import { render, staticRenderFns } from "./ArtistPros.vue?vue&type=template&id=4d521949&scoped=true"
import script from "./ArtistPros.vue?vue&type=script&lang=ts"
export * from "./ArtistPros.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d521949",
  null
  
)

export default component.exports